<div class="vendor">
  <div class="vendor_image">
    <img class="vendor_image--img" [src]="vendor.imageUrl ? vendor.imageUrl: image"/>
  </div>
  <div class="vendor_right">
    <div class="vendor_item">
      <span >{{vendor.vendorItemName}}</span>
      <span>{{vendor.price | currency}}</span>
    </div>
    <div class="vendor_chips">
      <app-sku-chip [name]="'vendorName'"
                    [value]="vendor.vendorName"
                    (click)="stopPropagation($event)"
                    class="vendor_chip"
      ></app-sku-chip>
      <app-sku-chip
              [name]="'vendorId'"
              [value]="vendor.vendorId"
              (click)="stopPropagation($event)"
              class="vendor_chip"
      ></app-sku-chip>
    </div>
  </div>
</div>
